module.exports = __webpack_public_path__ + "static/media/JM_iconos-01_favorito_desac.53f132f2.svg";